
// import React, { useEffect, useState } from 'react';
// import {
//   Box,
//   Grid,
//   Card,
//   CardMedia,
//   CardContent,
//   Typography,
//   Button,
//   useMediaQuery,
//   CircularProgress,
//   Snackbar,
//   Alert,
//   Pagination,
//   TextField,
//   Select,
//   MenuItem,
//   InputAdornment,
// } from '@mui/material';
// import { useTheme } from '@mui/material/styles';
// import { useSelector } from 'react-redux';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// // Import Material-UI icons instead of image assets
// import BedIcon from '@mui/icons-material/Bed';
// import BathtubIcon from '@mui/icons-material/Bathtub';
// import SquareFootIcon from '@mui/icons-material/SquareFoot';
// // Keep only the heart icon image
// import heartIcon from '../../../assets/logheart.png';

// const PropertyListingPage = () => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const isLoggedIn = useSelector(state => state.user.isAuthenticated);
//   const userData = useSelector(state => state.user.user);
//   const location = useLocation();
//   const navigate = useNavigate();

//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [favoriteLoading, setFavoriteLoading] = useState({});
//   const [favoriteProperties, setFavoriteProperties] = useState([]);

//   // Pagination states
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [limit, setLimit] = useState(12);
//   const [totalProperties, setTotalProperties] = useState(0);

//   // Search form states
//   const [citySearch, setCitySearch] = useState('');
//   const [areaSearch, setAreaSearch] = useState('');
//   const [propertyType, setPropertyType] = useState('');
//   const [priceRange, setPriceRange] = useState('');
//   const [citySuggestions, setCitySuggestions] = useState([]);
//   const [showCitySuggestions, setShowCitySuggestions] = useState(false);
//   const [areaSuggestions, setAreaSuggestions] = useState([]);
//   const [showAreaSuggestions, setShowAreaSuggestions] = useState(false);

//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     message: '',
//     severity: 'success'
//   });

//   const handleCloseSnackbar = () => {
//     setSnackbar({ ...snackbar, open: false });
//   };

//   const showSnackbar = (message, severity = 'success') => {
//     setSnackbar({
//       open: true,
//       message,
//       severity
//     });
//   };

//   const handlePageChange = (event, newPage) => {
//     setPage(newPage);
//     window.scrollTo(0, 0);
//   };

//   // ✅ Helper function to check if value is valid
//   const isValidValue = (value) => {
//     return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
//   };

//   // ✅ Helper function to check if image has valid data
//   const hasValidImage = (base64) => {
//     return base64 && base64.length > 100 && base64 !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEkoSeleaKApYsGNby651rbv2Xte1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=";
//   };

//   // Parse the initial URL parameters when the component mounts
//   useEffect(() => {
//     const queryParams = new URLSearchParams(location.search);
//     const cityParam = queryParams.get('city');
//     const areaParam = queryParams.get('area_name');
//     const typeParam = queryParams.get('property_type');

//     setCitySearch(cityParam || '');
//     setAreaSearch(areaParam || '');
//     setPropertyType(typeParam || '');
//     setPage(1);
//   }, [location.search]);

//   // Fetch properties based on search parameters
//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         const apiUrl = 'https://propertydealstalk.com/api/property/filterProperties';
//         const queryParams = new URLSearchParams(location.search);

//         if (queryParams.get('type_of_category') === 'buy') {
//           queryParams.set('type_of_category', 'sale');
//         }

//         queryParams.set('page', page);
//         queryParams.set('limit', limit);

//         let url = apiUrl;
//         if (queryParams.toString()) {
//           url = `${apiUrl}?${queryParams.toString()}`;
//         } else {
//           url = `${apiUrl}?type_of_category=sale&page=${page}&limit=${limit}`;
//         }

//         console.log('Fetching properties from:', url);
//         const response = await fetch(url);

//         if (!response.ok) {
//           throw new Error(`Server responded with status: ${response.status}`);
//         }

//         const data = await response.json();

//         if (data.statusCode === 200) {
//           setProperties(data.result.properties || []);
//           if (data.result.pagination) {
//             setTotalPages(data.result.pagination.totalPages || 1);
//             setTotalProperties(data.result.pagination.totalItems || 0);
//           } else if (data.result.total) {
//             setTotalPages(Math.ceil(data.result.total / limit));
//             setTotalProperties(data.result.total);
//           }
//           showSnackbar(`Found ${data.result.total || data.result.pagination?.totalItems || 0} properties`);
//         } else {
//           setError(`Failed to fetch properties: ${data.message || 'Unknown error'}`);
//           showSnackbar(`Failed to fetch properties: ${data.message || 'Unknown error'}`, 'error');
//         }
//       } catch (err) {
//         console.error('Error fetching properties:', err);
//         setError(`Failed to connect to the server: ${err.message}`);
//         showSnackbar(`Failed to connect to the server: ${err.message}`, 'error');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProperties();
//   }, [location.search, page, limit]);

//   // Fetch city suggestions
//   const fetchCitySuggestions = async (query) => {
//     if (query.length < 1) {
//       setCitySuggestions([]);
//       setShowCitySuggestions(false);
//       return;
//     }

//     try {
//       const response = await fetch(`https://www.propertydealstalk.com/api/property/cities?q=${query}`);
//       const data = await response.json();
//       if (data.success && data.cities) {
//         setCitySuggestions(data.cities);
//         setShowCitySuggestions(true);
//       }
//     } catch (error) {
//       console.error('Error fetching city suggestions:', error);
//       setCitySuggestions([]);
//       setShowCitySuggestions(false);
//     }
//   };

//   // Fetch area suggestions
//   const fetchAreaSuggestions = async (query) => {
//     if (!citySearch || citySearch.trim() === '') {
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//       return;
//     }

//     try {
//       const response = await fetch(`https://propertydealstalk.com/api/property/getAreasByCity?city=${encodeURIComponent(citySearch)}&q=${query}`);
//       const data = await response.json();
//       if (data.success && data.areas) {
//         setAreaSuggestions(data.areas);
//         setShowAreaSuggestions(true);
//       }
//     } catch (error) {
//       console.error('Error fetching area suggestions:', error);
//       setAreaSuggestions([]);
//       setShowAreaSuggestions(false);
//     }
//   };

//   const handleCityChange = (e) => {
//     const value = e.target.value;
//     setCitySearch(value);
//     fetchCitySuggestions(value);
//   };

//   const handleAreaChange = (e) => {
//     const value = e.target.value;
//     setAreaSearch(value);
//     fetchAreaSuggestions(value);
//   };

//   const handleSearch = () => {
//     const params = new URLSearchParams(location.search);

//     if (citySearch) params.set('city', citySearch);
//     else params.delete('city');

//     if (areaSearch) params.set('area_name', areaSearch);
//     else params.delete('area_name');

//     if (propertyType) params.set('property_type', propertyType);
//     else params.delete('property_type');

//     setPage(1);

//     navigate({
//       pathname: '/property',
//       search: params.toString()
//     }, { replace: true });
//   };

//   const handleAddToFavorites = async (propertyId) => {
//     if (!isLoggedIn || !userData) {
//       showSnackbar("Please log in to add properties to favorites", "warning");
//       return;
//     }

//     try {
//       setFavoriteLoading(prev => ({ ...prev, [propertyId]: true }));
//       const buyerId = userData.id;

//       if (!buyerId) {
//         console.error('Buyer ID not found in user data');
//         showSnackbar("User information missing. Please log in again.", "error");
//         return;
//       }

//       console.log('Adding to favorites with buyer_id:', buyerId, 'property_id:', propertyId);

//       const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           buyer_id: buyerId,
//           property_id: propertyId
//         }),
//       });

//       const data = await response.json();

//       if (data.statusCode === 200) {
//         console.log('Property added to favorites:', data.result);
//         setFavoriteProperties(prev => [...prev, propertyId]);
//         showSnackbar("Property added to favorites!");
//       } else {
//         console.error('Failed to add to favorites:', data.message);
//         showSnackbar(`Failed to add to favorites: ${data.message}`, "error");
//       }
//     } catch (err) {
//       console.error('Error adding to favorites:', err);
//       showSnackbar(`Error adding to favorites: ${err.message}`, "error");
//     } finally {
//       setFavoriteLoading(prev => ({ ...prev, [propertyId]: false }));
//     }
//   };

//   const recordPropertyView = async (propertyId) => {
//     if (!isLoggedIn || !userData) {
//       console.log('User not logged in, skipping view recording');
//       return;
//     }

//     try {
//       const userId = userData.id;
//       if (!userId) {
//         console.error('User ID not found in user data');
//         return;
//       }

//       console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

//       const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           user_id: userId,
//           property_id: propertyId
//         }),
//       });

//       const data = await response.json();

//       if (data.statusCode === 200) {
//         console.log('Property view recorded successfully:', data.result);
//       } else {
//         console.error('Failed to record property view:', data.message);
//       }
//     } catch (err) {
//       console.error('Error recording property view:', err);
//     }
//   };

//   const handlePropertyClick = (propertyId) => {
//     recordPropertyView(propertyId);
//     navigate(`/view/${propertyId}`);
//   };

//   // ✅ Updated getImageSrc to check for valid images
//   const getImageSrc = (property) => {
//     try {
//       if (property.image && hasValidImage(property.image)) {
//         return `data:image/jpeg;base64,${property.image}`;
//       }
//       if (property.images && typeof property.images === 'object' && property.images.image && hasValidImage(property.images.image)) {
//         return `data:image/jpeg;base64,${property.images.image}`;
//       }
//       if (property.images && Array.isArray(property.images) && property.images.length > 0) {
//         const firstImage = property.images[0];
//         if (firstImage && typeof firstImage === 'object' && firstImage.image && hasValidImage(firstImage.image)) {
//           return `data:image/jpeg;base64,${firstImage.image}`;
//         }
//       }
//       return null; // Return null if no valid image
//     } catch (error) {
//       console.error("Error processing image:", error);
//       return null;
//     }
//   };

//   const formatCurrency = (amount, currency = '₹') => {
//     if (!amount) return 'Price on request';
//     return `${currency}${amount.toLocaleString('en-IN')}`;
//   };

//   const isFavorite = (propertyId) => {
//     return favoriteProperties.includes(propertyId);
//   };

//   // ✅ Function to get property amenities (only valid ones)
//   const getPropertyAmenities = (property) => {
//     const amenities = [];

//     // Check BHK
//     if (isValidValue(property.bhk)) {
//       amenities.push({
//         icon: <BedIcon sx={{ color: '#666', fontSize: 18 }} />,
//         value: `${property.bhk} BHK`
//       });
//     }

//     // Check bathrooms
//     if (isValidValue(property.bathrooms)) {
//       amenities.push({
//         icon: <BathtubIcon sx={{ color: '#666', fontSize: 18 }} />,
//         value: `${property.bathrooms} Bath`
//       });
//     }

//     // Check property size
//     if (isValidValue(property.property_size)) {
//       const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
//       amenities.push({
//         icon: <SquareFootIcon sx={{ color: '#666', fontSize: 18 }} />,
//         value: `${property.property_size} ${sizeUnit}`
//       });
//     }

//     return amenities;
//   };

//   return (
//     <Box
//       sx={{
//         backgroundColor: '#fff',
//         fontFamily: 'Outfit',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//       }}
//     >
//       <Box
//         sx={{
//           backgroundColor: '#f9f9f9',
//           py: isMobile ? 4 : 6,
//           px: isMobile ? 2 : 4,
//           fontFamily: 'Outfit, sans-serif',
//           textAlign: 'center',
//           width: '100%'
//         }}
//       >
//         <Typography
//           variant="h5"
//           fontWeight={600}
//           mb={4}
//           sx={{
//             fontSize: isMobile ? '1.8rem' : '1.9rem'
//           }}
//         >
//           Find Your Perfect Property
//         </Typography>

//         <Box
//           sx={{
//             backgroundColor: '#fff',
//             borderRadius: '22px',
//             display: 'flex',
//             flexDirection: isMobile ? 'column' : 'row',
//             alignItems: 'center',
//             justifyContent: 'center',
//             p: 2,
//             boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
//             width: isMobile ? '100%' : '70%',
//             mx: 'auto',
//             gap: 2,
//             mb: 4,
//             flexWrap: 'wrap'
//           }}
//         >
//           <Box sx={{ position: 'relative', width: isMobile ? '100%' : '200px' }}>
//             <TextField
//               placeholder="City"
//               variant="outlined"
//               size="small"
//               value={citySearch}
//               onChange={handleCityChange}
//               onBlur={() => {
//                 setTimeout(() => setShowCitySuggestions(false), 300);
//               }}
//               onFocus={() => {
//                 if (citySearch.length >= 1) {
//                   fetchCitySuggestions(citySearch);
//                 }
//               }}
//               fullWidth
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <LocationOnIcon sx={{ color: '#999' }} />
//                   </InputAdornment>
//                 ),
//               }}
//             />
//             {showCitySuggestions && citySuggestions.length > 0 && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: '40px',
//                   left: 0,
//                   right: 0,
//                   zIndex: 10,
//                   maxHeight: '200px',
//                   overflowY: 'auto',
//                   backgroundColor: '#fff',
//                   boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//                   borderRadius: '4px',
//                   mt: '4px',
//                 }}
//               >
//                 {citySuggestions.map((suggestion, index) => (
//                   <Box
//                     key={index}
//                     sx={{
//                       padding: '8px 12px',
//                       cursor: 'pointer',
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5',
//                       },
//                       fontFamily: 'Outfit',
//                       fontWeight: 500,
//                       color: '#626262',
//                     }}
//                     onMouseDown={(e) => {
//                       e.preventDefault();
//                       setCitySearch(suggestion.name);
//                       setShowCitySuggestions(false);
//                       setAreaSearch('');
//                     }}
//                   >
//                     {suggestion.name}
//                   </Box>
//                 ))}
//               </Box>
//             )}
//           </Box>

//           <Box sx={{ position: 'relative', width: isMobile ? '100%' : '200px' }}>
//             <TextField
//               placeholder="Area"
//               variant="outlined"
//               size="small"
//               value={areaSearch}
//               onChange={handleAreaChange}
//               onBlur={() => {
//                 setTimeout(() => setShowAreaSuggestions(false), 300);
//               }}
//               onFocus={() => {
//                 if (citySearch) {
//                   fetchAreaSuggestions(areaSearch);
//                 }
//               }}
//               fullWidth
//             />
//             {showAreaSuggestions && areaSuggestions.length > 0 && (
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   top: '40px',
//                   left: 0,
//                   right: 0,
//                   zIndex: 10,
//                   maxHeight: '200px',
//                   overflowY: 'auto',
//                   backgroundColor: '#fff',
//                   boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
//                   borderRadius: '4px',
//                   mt: '4px',
//                 }}
//               >
//                 {areaSuggestions.map((suggestion, index) => (
//                   <Box
//                     key={index}
//                     sx={{
//                       padding: '8px 12px',
//                       cursor: 'pointer',
//                       '&:hover': {
//                         backgroundColor: '#f5f5f5',
//                       },
//                       fontFamily: 'Outfit',
//                       fontWeight: 500,
//                       color: '#626262',
//                     }}
//                     onMouseDown={(e) => {
//                       e.preventDefault();
//                       setAreaSearch(suggestion.name);
//                       setShowAreaSuggestions(false);
//                     }}
//                   >
//                     {suggestion.name}
//                   </Box>
//                 ))}
//               </Box>
//             )}
//           </Box>

//           <Select
//             value={propertyType}
//             onChange={(e) => setPropertyType(e.target.value)}
//             displayEmpty
//             size="small"
//             sx={{ width: isMobile ? '100%' : '200px' }}
//           >
//             <MenuItem value="" disabled>
//               Property Type
//             </MenuItem>
//             <MenuItem value="residential">Residential</MenuItem>
//             <MenuItem value="commercial">Commercial</MenuItem>
//             <MenuItem value="plot">Plot</MenuItem>
//           </Select>

//           <Select
//             value={priceRange}
//             onChange={(e) => setPriceRange(e.target.value)}
//             displayEmpty
//             size="small"
//             sx={{ width: isMobile ? '100%' : '200px' }}
//           >
//             <MenuItem value="" disabled>
//               Price Range
//             </MenuItem>
//             <MenuItem value="Below ₹10L">Below ₹10L</MenuItem>
//             <MenuItem value="₹10L - ₹50L">₹10L - ₹50L</MenuItem>
//             <MenuItem value="₹50L - ₹1Cr">₹50L - ₹1Cr</MenuItem>
//             <MenuItem value="Above ₹1Cr">Above ₹1Cr</MenuItem>
//           </Select>

//           <Button
//             onClick={handleSearch}
//             variant="contained"
//             sx={{
//               bgcolor: '#0052ff',
//               color: '#fff',
//               height: 40,
//               px: 4,
//               borderRadius: 1,
//               textTransform: 'none',
//               width: isMobile ? '100%' : 'auto'
//             }}
//           >
//             Search
//           </Button>
//         </Box>
//       </Box>

//       <Box
//         sx={{
//           px: isMobile ? 2 : 4,
//           pb: 5,
//           display: 'flex',
//           flexDirection: 'column',
//           alignItems: 'center',
//           width: '100%'
//         }}
//       >
//         <Snackbar
//           open={snackbar.open}
//           autoHideDuration={3000}
//           onClose={handleCloseSnackbar}
//           anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
//         >
//           <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
//             {snackbar.message}
//           </Alert>
//         </Snackbar>

//         {!loading && properties.length > 0 && (
//           <Box sx={{ width: '100%', maxWidth: '1440px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//             <Typography variant="body2" color="textSecondary">
//               Showing {((page - 1) * limit) + 1}-{Math.min(page * limit, totalProperties)} of {totalProperties} properties
//             </Typography>
//           </Box>
//         )}

//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
//             <CircularProgress />
//           </Box>
//         ) : error ? (
//           <Box sx={{ textAlign: 'center', mt: 4 }}>
//             <Typography variant="h6" color="error">
//               {error}
//             </Typography>
//           </Box>
//         ) : properties.length === 0 ? (
//           <Box sx={{ textAlign: 'center', mt: 4 }}>
//             <Typography variant="h6">
//               No properties found matching your criteria.
//             </Typography>
//           </Box>
//         ) : (
//           <>
//             <Grid
//               container
//               spacing={3}
//               justifyContent="center"
//               alignItems="flex-start"
//               sx={{
//                 maxWidth: '1440px',
//                 mx: 'auto',
//               }}
//             >
//               {properties.map((property, index) => {
//                 const imageSrc = getImageSrc(property);
//                 const amenities = getPropertyAmenities(property);

//                 return (
//                   <Grid item key={property.id} xs="auto">
//                     <Card
//                       sx={{
//                         width: 340,
//                         borderRadius: '12px',
//                         boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
//                         overflow: 'hidden',
//                         transition: 'transform 0.3s ease',
//                         display: 'flex',
//                         flexDirection: 'column',
//                         height: '100%', // ✅ Fixed height for even cards
//                         '&:hover': {
//                           transform: 'translateY(-5px)',
//                         },
//                       }}
//                     >
//                       <Box sx={{ position: 'relative', height: 180 }}>
//                         {imageSrc ? (
//                           <CardMedia
//                             component="img"
//                             image={imageSrc}
//                             alt="Property"
//                             sx={{
//                               width: '100%',
//                               height: '100%',
//                               objectFit: 'cover',
//                             }}
//                           />
//                         ) : (
//                           <Box
//                             sx={{
//                               width: '100%',
//                               height: '100%',
//                               display: 'flex',
//                               alignItems: 'center',
//                               justifyContent: 'center',
//                               backgroundColor: '#f5f5f5',
//                               border: '1px dashed #ccc'
//                             }}
//                           >
//                             <Typography variant="body2" color="#888" textAlign="center" px={2}>
//                               No images uploaded
//                             </Typography>
//                           </Box>
//                         )}

//                         {index < 4 && (
//                           <Box
//                             sx={{
//                               position: 'absolute',
//                               top: 10,
//                               left: 10,
//                               backgroundColor: '#f7931e',
//                               color: '#fff',
//                               px: 2,
//                               py: '2px',
//                               borderRadius: '10px',
//                               fontSize: '13px',
//                               fontWeight: 500,
//                             }}
//                           >
//                             Featured
//                           </Box>
//                         )}

//                         {isLoggedIn && (
//                           <Box
//                             component="img"
//                             src={heartIcon}
//                             alt="heart"
//                             onClick={(e) => {
//                               e.stopPropagation();
//                               handleAddToFavorites(property.id);
//                             }}
//                             sx={{
//                               position: 'absolute',
//                               top: 10,
//                               right: 10,
//                               width: 28,
//                               height: 28,
//                               backgroundColor: '#fff',
//                               borderRadius: '50%',
//                               padding: '4px',
//                               boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
//                               cursor: 'pointer',
//                               opacity: favoriteLoading[property.id] ? 0.6 : 1,
//                               transition: 'all 0.2s',
//                               filter: isFavorite(property.id) ? 'invert(13%) sepia(95%) saturate(7466%) hue-rotate(0deg) brightness(99%) contrast(115%)' : 'none',
//                               '&:hover': {
//                                 transform: 'scale(1.1)',
//                               },
//                             }}
//                           />
//                         )}
//                       </Box>

//                       <CardContent
//                         sx={{
//                           px: 2,
//                           pt: 2,
//                           pb: 3,
//                           display: 'flex',
//                           flexDirection: 'column',
//                           gap: '8px',
//                           flexGrow: 1, // ✅ Allow content to grow
//                         }}
//                       >
//                         <Box
//                           sx={{
//                             display: 'flex',
//                             justifyContent: 'space-between',
//                             alignItems: 'flex-start', // ✅ Changed to flex-start
//                             gap: 1,
//                           }}
//                         >
//                           <Typography 
//                             sx={{ 
//                               fontSize: '16px', 
//                               fontWeight: 600,
//                               overflow: 'hidden',
//                               textOverflow: 'ellipsis',
//                               display: '-webkit-box',
//                               WebkitLineClamp: 2, // ✅ Limit to 2 lines
//                               WebkitBoxOrient: 'vertical',
//                               lineHeight: 1.3,
//                               minHeight: '41px', // ✅ Fixed height for 2 lines
//                               flex: 1,
//                             }}
//                           >
//                             {property.property_name || property.asset_type || 'Property'}
//                           </Typography>
//                           <Typography
//                             sx={{
//                               fontSize: '14px',
//                               fontWeight: 500,
//                               color: '#2563EB',
//                               whiteSpace: 'nowrap',
//                             }}
//                           >
//                             {property.asking_price
//                               ? formatCurrency(property.asking_price, property.currency)
//                               : (property.monthly_rent
//                                 ? formatCurrency(property.monthly_rent, property.currency) + '/mo'
//                                 : 'Price on request')}
//                           </Typography>
//                         </Box>

//                         <Box
//                           sx={{
//                             display: 'flex',
//                             alignItems: 'center',
//                             gap: 1,
//                             fontSize: '14px',
//                             color: '#555',
//                             minHeight: '24px', // ✅ Fixed height for location
//                           }}
//                         >
//                           <LocationOnIcon fontSize="small" sx={{ color: '#666' }} />
//                           <Typography
//                             sx={{
//                               fontSize: '14px',
//                               overflow: 'hidden',
//                               textOverflow: 'ellipsis',
//                               whiteSpace: 'nowrap',
//                             }}
//                           >
//                             {property.location}, {property.area_name || ''}
//                           </Typography>
//                         </Box>

//                                                 {/* ✅ Only show amenities if they exist */}
//                         {amenities.length > 0 && (
//                           <Box
//                             sx={{
//                               display: 'flex',
//                               justifyContent: 'space-around',
//                               alignItems: 'center',
//                               mt: 1,
//                               gap: 1,
//                               minHeight: '30px', // ✅ Fixed height for amenities section
//                             }}
//                           >
//                             {amenities.map((amenity, idx) => (
//                               <Box
//                                 key={idx}
//                                 sx={{
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   gap: 0.5,
//                                 }}
//                               >
//                                 {amenity.icon}
//                                 <Typography
//                                   sx={{
//                                     fontSize: '13px',
//                                     color: '#666',
//                                     fontWeight: 500,
//                                   }}
//                                 >
//                                   {amenity.value}
//                                 </Typography>
//                               </Box>
//                             ))}
//                           </Box>
//                         )}

//                         <Button
//                           onClick={() => handlePropertyClick(property.id)}
//                           variant="contained"
//                           sx={{
//                             mt: 'auto', // ✅ Push button to bottom
//                             backgroundColor: '#005eff',
//                             color: '#fff',
//                             borderRadius: '6px',
//                             textTransform: 'none',
//                             fontWeight: 500,
//                             px: 4,
//                             py: 1.2,
//                             width: '100%',
//                             '&:hover': {
//                               backgroundColor: '#004ecb',
//                             },
//                           }}
//                         >
//                           View Property
//                         </Button>
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 );
//               })}
//             </Grid>

//             {totalPages > 1 && (
//               <Box sx={{ mt: 5, display: 'flex', justifyContent: 'center' }}>
//                 <Pagination
//                   count={totalPages}
//                   page={page}
//                   onChange={handlePageChange}
//                   color="primary"
//                   size={isMobile ? "small" : "medium"}
//                   showFirstButton
//                   showLastButton
//                 />
//               </Box>
//             )}
//           </>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default PropertyListingPage;
                


import React, { useEffect, useState } from 'react';
import {
  Box,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  useMediaQuery,
  CircularProgress,
  Snackbar,
  Alert,
  Pagination,
  Select,
  MenuItem,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Link, useLocation, useNavigate } from 'react-router-dom';
// Import Material-UI icons instead of image assets
import BedIcon from '@mui/icons-material/Bed';
import BathtubIcon from '@mui/icons-material/Bathtub';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
// Keep only the heart icon image
import heartIcon from '../../../assets/logheart.png';

const PropertyListingPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isLoggedIn = useSelector(state => state.user.isAuthenticated);
  const userData = useSelector(state => state.user.user);
  const location = useLocation();
  const navigate = useNavigate();

  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [favoriteLoading, setFavoriteLoading] = useState({});
  const [favoriteProperties, setFavoriteProperties] = useState([]);

  // Pagination states
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(12);
  const [totalProperties, setTotalProperties] = useState(0);

  // Search form states
  const [propertyType, setPropertyType] = useState('');
  const [priceRange, setPriceRange] = useState('');

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({
      open: true,
      message,
      severity
    });
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    window.scrollTo(0, 0);
  };

  // ✅ Helper function to check if value is valid
  const isValidValue = (value) => {
    return value && value !== 'N/A' && value !== 'null' && value !== null && value !== undefined && value.toString().trim() !== '';
  };

  // ✅ Helper function to check if image has valid data
  const hasValidImage = (base64) => {
    return base64 && base64.length > 100 && base64 !== "iVBORw0KGgoAAAANSUhEUgAAB4AAAAQ4CAYAAADo08FDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAP+6SURBVHhe7N13fFRV/sbxz52aNqSHEkoSeleaKApYsGNby651rbv2Xte1rb3gWra46tpiXqHUNAAAAAASUVORK5CYII=";
  };

  // Parse the initial URL parameters when the component mounts
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const typeParam = queryParams.get('property_type');
    setPropertyType(typeParam || '');
    setPage(1);
  }, [location.search]);

  // Fetch properties based on search parameters
  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        const apiUrl = 'https://propertydealstalk.com/api/property/filterProperties';
        const queryParams = new URLSearchParams(location.search);

        if (queryParams.get('type_of_category') === 'buy') {
          queryParams.set('type_of_category', 'sale');
        }

        queryParams.set('page', page);
        queryParams.set('limit', limit);

        let url = apiUrl;
        if (queryParams.toString()) {
          url = `${apiUrl}?${queryParams.toString()}`;
        } else {
          url = `${apiUrl}?type_of_category=sale&page=${page}&limit=${limit}`;
        }

        console.log('Fetching properties from:', url);
        const response = await fetch(url);

        if (!response.ok) {
          throw new Error(`Server responded with status: ${response.status}`);
        }

        const data = await response.json();

        if (data.statusCode === 200) {
          setProperties(data.result.properties || []);
          if (data.result.pagination) {
            setTotalPages(data.result.pagination.totalPages || 1);
            setTotalProperties(data.result.pagination.totalItems || 0);
          } else if (data.result.total) {
            setTotalPages(Math.ceil(data.result.total / limit));
            setTotalProperties(data.result.total);
          }
          showSnackbar(`Found ${data.result.total || data.result.pagination?.totalItems || 0} properties`);
        } else {
          setError(`Failed to fetch properties: ${data.message || 'Unknown error'}`);
          showSnackbar(`Failed to fetch properties: ${data.message || 'Unknown error'}`, 'error');
        }
      } catch (err) {
        console.error('Error fetching properties:', err);
        setError(`Failed to connect to the server: ${err.message}`);
        showSnackbar(`Failed to connect to the server: ${err.message}`, 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, [location.search, page, limit]);

  const handleSearch = () => {
    const params = new URLSearchParams(location.search);

    if (propertyType) params.set('property_type', propertyType);
    else params.delete('property_type');

    setPage(1);
    navigate({
      pathname: '/property',
      search: params.toString()
    }, { replace: true });
  };

  const handleAddToFavorites = async (propertyId) => {
    if (!isLoggedIn || !userData) {
      showSnackbar("Please log in to add properties to favorites", "warning");
      return;
    }

    try {
      setFavoriteLoading(prev => ({ ...prev, [propertyId]: true }));

      const buyerId = userData.id;
      if (!buyerId) {
        console.error('Buyer ID not found in user data');
        showSnackbar("User information missing. Please log in again.", "error");
        return;
      }

      console.log('Adding to favorites with buyer_id:', buyerId, 'property_id:', propertyId);

      const response = await fetch('https://propertydealstalk.com/api/buyer/addFavorites', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          buyer_id: buyerId,
          property_id: propertyId
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        console.log('Property added to favorites:', data.result);
        setFavoriteProperties(prev => [...prev, propertyId]);
        showSnackbar("Property added to favorites!");
      } else {
        console.error('Failed to add to favorites:', data.message);
        showSnackbar(`Failed to add to favorites: ${data.message}`, "error");
      }
    } catch (err) {
      console.error('Error adding to favorites:', err);
      showSnackbar(`Error adding to favorites: ${err.message}`, "error");
    } finally {
      setFavoriteLoading(prev => ({ ...prev, [propertyId]: false }));
    }
  };

  const recordPropertyView = async (propertyId) => {
    if (!isLoggedIn || !userData) {
      console.log('User not logged in, skipping view recording');
      return;
    }

    try {
      const userId = userData.id;
      if (!userId) {
        console.error('User ID not found in user data');
        return;
      }

      console.log('Recording property view with user_id:', userId, 'property_id:', propertyId);

      const response = await fetch('https://propertydealstalk.com/api/buyer/recordPropertyView', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          user_id: userId,
          property_id: propertyId
        }),
      });

      const data = await response.json();

      if (data.statusCode === 200) {
        console.log('Property view recorded successfully:', data.result);
      } else {
        console.error('Failed to record property view:', data.message);
      }
    } catch (err) {
      console.error('Error recording property view:', err);
    }
  };

  const handlePropertyClick = (propertyId) => {
    recordPropertyView(propertyId);
    navigate(`/view/${propertyId}`);
  };

  // ✅ Updated getImageSrc to check for valid images
  const getImageSrc = (property) => {
    try {
      if (property.image && hasValidImage(property.image)) {
        return `data:image/jpeg;base64,${property.image}`;
      }

      if (property.images && typeof property.images === 'object' && property.images.image && hasValidImage(property.images.image)) {
        return `data:image/jpeg;base64,${property.images.image}`;
      }

      if (property.images && Array.isArray(property.images) && property.images.length > 0) {
       const firstImage = property.images[0];
        if (firstImage && typeof firstImage === 'object' && firstImage.image && hasValidImage(firstImage.image)) {
          return `data:image/jpeg;base64,${firstImage.image}`;
        }
      }

      return null; // Return null if no valid image
    } catch (error) {
      console.error("Error processing image:", error);
      return null;
    }
  };

  const formatCurrency = (amount, currency = '₹') => {
    if (!amount) return 'Price on request';
    return `${currency}${amount.toLocaleString('en-IN')}`;
  };

  const isFavorite = (propertyId) => {
    return favoriteProperties.includes(propertyId);
  };

  // ✅ Function to get property amenities (only valid ones)
  const getPropertyAmenities = (property) => {
    const amenities = [];

    // Check BHK
    if (isValidValue(property.bhk)) {
      amenities.push({
        icon: <BedIcon sx={{ color: '#666', fontSize: 18 }} />,
        value: `${property.bhk} BHK`
      });
    }

    // Check bathrooms
    if (isValidValue(property.bathrooms)) {
      amenities.push({
        icon: <BathtubIcon sx={{ color: '#666', fontSize: 18 }} />,
        value: `${property.bathrooms} Bath`
      });
    }

    // Check property size
    if (isValidValue(property.property_size)) {
      const sizeUnit = isValidValue(property.property_size_units) ? property.property_size_units : 'sq.ft';
      amenities.push({
        icon: <SquareFootIcon sx={{ color: '#666', fontSize: 18 }} />,
        value: `${property.property_size} ${sizeUnit}`
      });
    }

    return amenities;
  };

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        fontFamily: 'Outfit',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#f9f9f9',
          py: isMobile ? 4 : 6,
          px: isMobile ? 2 : 4,
          fontFamily: 'Outfit, sans-serif',
          textAlign: 'center',
          width: '100%'
        }}
      >
        <Typography
          variant="h5"
          fontWeight={600}
          mb={4}
          sx={{
            fontSize: isMobile ? '1.8rem' : '1.9rem'
          }}
        >
          Find Your Perfect Property
        </Typography>

        <Box
          sx={{
            backgroundColor: '#fff',
            borderRadius: '22px',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center',
            justifyContent: 'center',
            p: 2,
            boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
            width: isMobile ? '100%' : '50%', // ✅ Reduced from 70% to 50%
            mx: 'auto',
            gap: 2,
            mb: 4,
            flexWrap: 'wrap'
          }}
        >
          <Select
            value={propertyType}
            onChange={(e) => setPropertyType(e.target.value)}
            displayEmpty
            size="small"
            sx={{ width: isMobile ? '100%' : '200px' }}
          >
            <MenuItem value="" disabled>
              Property Type
            </MenuItem>
            <MenuItem value="residential">Residential</MenuItem>
            <MenuItem value="commercial">Commercial</MenuItem>
            {/* ✅ Removed Plot option */}
          </Select>

          <Select
            value={priceRange}
            onChange={(e) => setPriceRange(e.target.value)}
            displayEmpty
            size="small"
            sx={{ width: isMobile ? '100%' : '200px' }}
          >
            <MenuItem value="" disabled>
              Price Range
            </MenuItem>
            <MenuItem value="Below ₹10L">Below ₹10L</MenuItem>
            <MenuItem value="₹10L - ₹50L">₹10L - ₹50L</MenuItem>
            <MenuItem value="₹50L - ₹1Cr">₹50L - ₹1Cr</MenuItem>
            <MenuItem value="Above ₹1Cr">Above ₹1Cr</MenuItem>
          </Select>

          <Button
            onClick={handleSearch}
            variant="contained"
            sx={{
              bgcolor: '#0052ff',
              color: '#fff',
              height: 40,
              px: 4,
              borderRadius: 1,
              textTransform: 'none',
              width: isMobile ? '100%' : 'auto'
            }}
          >
            Search
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          px: isMobile ? 2 : 4,
          pb: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%'
        }}
      >
        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
            {snackbar.message}
          </Alert>
        </Snackbar>

        {!loading && properties.length > 0 && (
          <Box sx={{ width: '100%', maxWidth: '1440px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="body2" color="textSecondary">
              Showing {((page - 1) * limit) + 1}-{Math.min(page * limit, totalProperties)} of {totalProperties} properties
            </Typography>
          </Box>
        )}

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
            <CircularProgress />
          </Box>
        ) : error ? (
          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Typography variant="h6" color="error">
              {error}
            </Typography>
          </Box>
        ) : properties.length === 0 ? (
          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <Typography variant="h6">
              No properties found matching your criteria.
            </Typography>
          </Box>
        ) : (
          <>
            <Grid
              container
              spacing={3}
              justifyContent="center"
              alignItems="flex-start"
              sx={{
                maxWidth: '1440px',
                mx: 'auto',
              }}
            >
              {properties.map((property, index) => {
                const imageSrc = getImageSrc(property);
                const amenities = getPropertyAmenities(property);

                return (
                  <Grid item key={property.id} xs="auto">
                    <Card
                      sx={{
                        width: 340,
                        borderRadius: '12px',
                        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                        overflow: 'hidden',
                        transition: 'transform 0.3s ease',
                        display: 'flex',
                        flexDirection: 'column',
                        height: '100%', // ✅ Fixed height for even cards
                        '&:hover': {
                          transform: 'translateY(-5px)',
                        },
                      }}
                    >
                      <Box sx={{ position: 'relative', height: 180 }}>
                        {imageSrc ? (
                          <CardMedia
                            component="img"
                            image={imageSrc}
                            alt="Property"
                            sx={{
                              width: '100%',
                              height: '100%',
                              objectFit: 'cover',
                            }}
                          />
                        ) : (
                          <Box
                            sx={{
                              width: '100%',
                              height: '100%',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: '#f5f5f5',
                              border: '1px dashed #ccc'
                            }}
                          >
                            <Typography variant="body2" color="#888" textAlign="center" px={2}>
                              No images uploaded
                            </Typography>
                          </Box>
                        )}

                        {index < 4 && (
                          <Box
                            sx={{
                              position: 'absolute',
                              top: 10,
                              left: 10,
                              backgroundColor: '#f7931e',
                              color: '#fff',
                              px: 2,
                              py: '2px',
                              borderRadius: '10px',
                              fontSize: '13px',
                              fontWeight: 500,
                            }}
                          >
                            Featured
                          </Box>
                        )}

                        {isLoggedIn && (
                          <Box
                            component="img"
                            src={heartIcon}
                            alt="heart"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleAddToFavorites(property.id);
                            }}
                            sx={{
                              position: 'absolute',
                              top: 10,
                              right: 10,
                              width: 28,
                              height: 28,
                              backgroundColor: '#fff',
                              borderRadius: '50%',
                              padding: '4px',
                              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                              cursor: 'pointer',
                              opacity: favoriteLoading[property.id] ? 0.6 : 1,
                              transition: 'all 0.2s',
                              filter: isFavorite(property.id) ? 'invert(13%) sepia(95%) saturate(7466%) hue-rotate(0deg) brightness(99%) contrast(115%)' : 'none',
                              '&:hover': {
                                transform: 'scale(1.1)',
                              },
                            }}
                          />
                        )}
                      </Box>

                      <CardContent
                        sx={{
                          px: 2,
                          pt: 2,
                          pb: 3,
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '8px',
                          flexGrow: 1, // ✅ Allow content to grow
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start', // ✅ Changed to flex-start
                            gap: 1,
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '16px',
                              fontWeight: 600,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 2, // ✅ Limit to 2 lines
                              WebkitBoxOrient: 'vertical',
                              lineHeight: 1.3,
                              minHeight: '41px', // ✅ Fixed height for 2 lines
                              flex: 1,
                            }}
                          >
                            {property.property_name || property.asset_type || 'Property'}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: '14px',
                              fontWeight: 500,
                              color: '#2563EB',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {property.asking_price
                              ? formatCurrency(property.asking_price, property.currency)
                              : (property.monthly_rent
                                ? formatCurrency(property.monthly_rent, property.currency) + '/mo'
                                : 'Price on request')}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            fontSize: '14px',
                            color: '#555',
                            minHeight: '24px', // ✅ Fixed height for location
                          }}
                        >
                          <LocationOnIcon fontSize="small" sx={{ color: '#666' }} />
                          <Typography
                            sx={{
                              fontSize: '14px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {property.location}, {property.area_name || ''}
                          </Typography>
                        </Box>

                        {/* ✅ Only show amenities if they exist */}
                        {amenities.length > 0 && (
                          <Box
                            sx={{
                              display: 'flex',
                              justifyContent: 'space-around',
                              alignItems: 'center',
                              mt: 1,
                              gap: 1,
                              minHeight: '30px', // ✅ Fixed height for amenities section
                            }}
                          >
                            {amenities.map((amenity, idx) => (
                              <Box
                                key={idx}
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 0.5,
                                }}
                              >
                                {amenity.icon}
                                <Typography
                                  sx={{
                                    fontSize: '13px',
                                    color: '#666',
                                    fontWeight: 500,
                                  }}
                                >
                                  {amenity.value}
                                </Typography>
                              </Box>
                            ))}
                          </Box>
                        )}

                        <Button
                          onClick={() => handlePropertyClick(property.id)}
                          variant="contained"
                          sx={{
                            mt: 'auto', // ✅ Push button to bottom
                            backgroundColor: '#005eff',
                            color: '#fff',
                            borderRadius: '6px',
                            textTransform: 'none',
                            fontWeight: 500,
                            px: 4,
                            py: 1.2,
                            width: '100%',
                            '&:hover': {
                              backgroundColor: '#004ecb',
                            },
                          }}
                        >
                          View Property
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>

            {totalPages > 1 && (
              <Box sx={{ mt: 5, display: 'flex', justifyContent: 'center' }}>
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                  size={isMobile ? "small" : "medium"}
                  showFirstButton
                  showLastButton
                />
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default PropertyListingPage;